import React from 'react';
import PropTypes from 'prop-types';

// DS
import { VertAlert } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/ToastAlert/ToastAlertStyles.less';

// CART ALERT COMPONENT
const ToastAlert = ({ ...props }) => {
  const { message, size } = props;

  return (
    <VertAlert
      {...props}
      className={`toast-alert ${props?.className || ''}`}
      message={message}
      size={size}
    />
  );
};

ToastAlert.propTypes = {
  size: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ToastAlert;
